import { call, put } from "redux-saga/effects";
import { logger } from "utils/logger";
import { toast } from "react-toastify";
import { goBack, push } from "connected-react-router";
import { qsStringify } from "../../utils/helper";
import { VERTICALS } from "../../utils/constants";
import { getOrdersAPI } from "../../api/order";
import { orderActions } from "../../actions/order";
import * as homeCareBulkCancelActions from "../../actions/order/homecareBulkCancelActions";
import {
  getHomeCareBulkOrdersByReferenceAPI,
  cancelHomeCareBulkOrdersAPI
} from "../../api/order/homecareBulkCancel";

export function* getHomeCareBulkCancelOrders({ payload }) {
  try {
    const resp = yield call(
      getHomeCareBulkOrdersByReferenceAPI,
      payload.bulkReference
    );
    if (resp) {
      yield put(
        homeCareBulkCancelActions.getHomeCareBulkCancelOrdersSuccess(resp.data)
      );
    }
  } catch (error) {
    logger.error(error);
    yield put(
      homeCareBulkCancelActions.getHomeCareBulkCancelOrdersFailure(error)
    );
  }
}

export function* cancelHomeCareBulkOrders({ payload }) {
  try {
    const { filter, redirectPath, goBackAfterSuccess } = payload;
    const resp = yield call(cancelHomeCareBulkOrdersAPI, {
      orderIds: payload.orderIds,
      cancellationStringId: payload.cancellationStringId,
      reason: payload.reason
    });
    if (resp) {
      yield put(
        homeCareBulkCancelActions.cancelHomeCareBulkOrdersSuccess(resp.data)
      );
      const { cancelledCount, skippedCount } = resp.data;
      if (cancelledCount > 0) {
        toast.success(
          `Cancelled ${cancelledCount} order${cancelledCount === 1 ? "" : "s"}`
        );
      }
      if (skippedCount > 0) {
        toast.warn(
          `${skippedCount} order${skippedCount === 1 ? "" : "s"} could not be cancelled`
        );
      }
      if (filter) {
        const orders = yield call(getOrdersAPI, {
          ...filter,
          vertical: VERTICALS.homecare
        });
        if (orders) {
          yield put(orderActions.getFilteredOrdersSuccess(orders.data));
        }
      }
      if (goBackAfterSuccess) {
        yield put(goBack());
      } else if (redirectPath) {
        yield put(push(redirectPath));
      } else {
        yield put(push(`/${VERTICALS.homecare}/orders`));
      }
    }
  } catch (error) {
    logger.error(error);
    yield put(homeCareBulkCancelActions.cancelHomeCareBulkOrdersFailure(error));
  }
}
